<template>
  <div class="container">
    <home-title
      title="学员作品"
      link2="/works"
      :icon="require('@/assets/images/home/home_title/icon8.svg')"
      :newWindow="true"
    ></home-title>
    <div class="work_box dfFw">
      <div
        class="work_item ta3"
        v-for="e in workList"
        :key="e.id"
        @click="goWorks(e.id)"
      >
        <div class="work_top dfJsbAc">
          <div class="top_left">
            <img :src="$prefixSrc(e.avatar)" alt="" />
            <span>
              <p class="user_name toh">{{ e.author_name }}</p>
              <p class="user_org toh">
                {{ e.author_lib_name }}
              </p>
            </span>
          </div>
          <div class="top_right">
            <div v-if="e.works_type == 3" class="work_c dfAcJc">
              <img src="@/assets/images/home/work_c.png" alt="" />课程作品
            </div>
            <div v-else class="work_a dfAcJc">
              <img src="@/assets/images/home/work_a.png" alt="" />活动作品
            </div>
          </div>
        </div>
        <div
          class="work_img"
          :style="`background:url('${$prefixSrc(e.cover)}') no-repeat`"
        ></div>
        <p class="work_title toh">
          {{ e.works_name }}
        </p>
        <div class="work_bottom dfJsbAc">
          <div class="data">
            <div class="icondata">
              <div class="icWrap">
                <img src="@/assets/images/newImg/eye.png" class="df100" />
              </div>
              <span>{{ e.watch_number }}</span>
            </div>
            <div class="icondata">
              <div class="icWrap">
                <img src="@/assets/images/newImg/info.png" class="df100" />
              </div>
              <span>{{ e.comments }}</span>
            </div>
            <div class="icondata">
              <div class="icWrap">
                <img src="@/assets/images/newImg/zan.png" class="df100" />
              </div>
              <span>{{ e.like_number }}</span>
            </div>
          </div>
          <div class="up_time">{{ e.created_at.split(" ")[0] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getIndexStdworks } from "@/api/home";
export default {
  name: "studentWork",
  components: { homeTitle },
  data() {
    return {
      workList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getIndexStdworks().then((res) => {
        this.workList = res.data;
      });
    },
    goWorks(id) {
      let routeData = this.$router.resolve({
        path: `/stuWorkdtcms/${id}`,
      });
      window.open(routeData.href);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 50px 0;
  .work_box {
    .work_item {
      width: 327px;
      height: 336px;
      border-radius: 10px;
      background: #fff;
      cursor: pointer;
      padding: 16px 16px 0;
      margin: 0 24px 24px 0;
      &:hover {
        -moz-transform: translateY(-10px);
        -webkit-transform: translateY(-10px);
        -o-transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        transform: translateY(-10px);
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      .work_top {
        margin-bottom: 24px;
        .top_left {
          display: flex;
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 10px;
            background: #cfcfcf;
          }
          p {
            max-width: 150px;
            font-size: 12px;
            line-height: 16px;
          }
          .user_name {
            color: #333;
          }
          .user_org {
            color: #999;
          }
        }
        .top_right {
          div {
            width: 85px;
            height: 25px;
            border-radius: 5px;
            font-size: 12px;
            line-height: 14px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 3px;
            }
          }

          .work_c {
            color: #22b79e;
            border: 1px solid #22b79e;
          }
          .work_a {
            color: #f90;
            border: 1px solid #f90;
          }
        }
      }
      .work_img {
        width: 100%;
        height: 178px;
        border-radius: 10px;
        background-size: cover !important;
        background-position: center center !important;
        -webkit-transform: rotate(0.001deg) translateZ(0);
      }
      .work_title {
        margin: 16px 0;
        font-size: 14px;
        line-height: 19px;
        color: #333;
      }
      .work_bottom {
        .data {
          display: flex;
          .icondata {
            margin-right: 15px;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #aaaaaa;
          }
          .icWrap {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
          i {
            font-size: 16px;
            padding-top: 2px;
            padding-right: 5px;
          }
        }
        .up_time {
          font-size: 12px;
          line-height: 16px;
          color: #999;
        }
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .work_box {
      .work_item {
        width: 260px;
        height: 270px;
        margin: 0 20px 20px 0;
        padding: 13px 12px 0;
        .work_top {
          margin-bottom: 16px;
          .top_left {
            p {
              max-width: 109px;
            }
          }
        }
        .work_img {
          height: 142px;
        }
        .work_title {
          margin: 10px 0 13px;
        }
      }
    }
  }
}
</style>
